import {getSession} from "@/utils";

export interface PortaitState {
  airConditioner: boolean,
  light: boolean
}

export const state: PortaitState = {
  airConditioner: getSession('portraitModule').airConditioner ? getSession('portraitModule').airConditioner : true,
  light: getSession('portraitModule').light ? getSession('portraitModule').light : true
}
